import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  CapitalAmount,
} from "../../../../app/slices/capitalAmountSlice";
import { Controller, useForm } from "react-hook-form";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CapitalAmountForm = () => {
  const _CapitalAmount = useSelector(
    (state) => state.capitalAmount.capitalAmount
  );
  const _SearchBody = useSelector((state) => state.capitalAmount.searchBody);
  const loading = _CapitalAmount.loading;

  const isAdd = _CapitalAmount.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      ..._CapitalAmount.form,
    },
  });

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(
        CapitalAmount.create({
          name: data.name,
          note: data.note,
        })
      );
    } else {
      dispatch(
        CapitalAmount.update(
          data.id,
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      );
    }
  };

  useEffect(() => {
    reset({
      ..._CapitalAmount.form,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_CapitalAmount.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <Dialog
      open={_CapitalAmount.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {isAdd ? "أضافة " : "تعديل "}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="الاسم"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="note"
                control={control}
                render={({ field }) => (
                  <TextField
                    multiline
                    rows={2}
                    size="small"
                    label="ملاحظات"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CapitalAmountForm;
